module.exports = __webpack_public_path__ + "img/and.be5030ca.webp";